const InternalPageTypes = {
    CLASS_RESOURCE: 'CLASS_RESOURCE',
    COURSE_RESOURCE: 'COURSE_RESOURCE',
    HOME_RESOURCE: 'HOME_RESOURCE',
};

export default InternalPageTypes;



// WEBPACK FOOTER //
// ./src/components/internal-pages/internal-page-types.js